module.exports = __webpack_public_path__ + "img/eiskaffeemithintergrund.e0e086bc.jpg";